import { BaseViewModel } from "app/based/baseViewModel/BaseViewModel";
import { DependenciesInjection } from "app/di/DependencyInjection";
import { LocalContext } from "context/AuthenticationContext";
import { Component, ContextType } from "react";
import { Location, Params } from "react-router-dom";
import { NextObserver, Observable } from "rxjs";

export interface IBaseViews {
  token: string | symbol;
  addtionalProps?: unknown;
  sharedVM?: BaseViewModel<Disposable, Disposable>;
  routeParams?: Readonly<Params<string>>;
  location?: Location<any>;
}

export abstract class BaseViews<
  VM extends BaseViewModel<Disposable, Disposable>, //ViewModel class
  S extends Object, // Props
  SS extends Object, // State mangement
> extends Component<IBaseViews & S, SS> {
  static contextType = LocalContext; //Context
  context: ContextType<typeof LocalContext>;
  viewModel: VM;

  constructor(props: IBaseViews & S) {
    super(props);
    this.viewModel = DependenciesInjection.lateResolution<VM>(this.props.token);
    this.bindViewModel = this.bindViewModel.bind(this);
  }

  //Subscribe method to check changes
  protected subscribeToVM<T>(
    observable: Observable<T>,
    next: (value: T) => void,
  ) {
    return observable.subscribe(next).add(this.viewModel.subscriptions);
  }
  
  //Connect method to apply value from subscription
  protected connectToVM<T>(nextObserver: NextObserver<T>, nextValue: T) {
    return nextObserver.next(nextValue);
  }

  protected bindViewModel(): void {
    this.viewModel.context = this.context;
  }

  protected dispose(): void {}

  protected update(): void {}

  componentDidMount(): void {
    this.bindViewModel();
  }

  override componentDidUpdate(): void {
    this.update();
  }

  componentWillUnmount(): void {
    this.dispose();
    if (typeof this.viewModel[Symbol.dispose] === "function") {
      this.viewModel[Symbol.dispose]();
    }
  }
}
